import React from "react";
import ProductionOrdersPage from "./ProductionOrdersPage";
import useProductionOrders from "./useProductionOrders";

function ProductionOrders() {
  return <ProductionOrdersPage {...useProductionOrders()} />;
}

export default ProductionOrders;
